<template>
  <span
    class="
      typography
      typography/tabular-numbers
    "
    v-html="time"
  />
</template>

<script>
export default {
  props: {
    time: { type: String, required: true }
  }
};
</script>
